/* Pass a Layout and Widgets to this Component to Render a Dashboard */
import React from "react";
import { WIDGET_COMPONENTS } from "../../Library/widgets";
import "../../Widgets/styles.css";
import { Button } from "@chakra-ui/react";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import { useNavigate } from "react-router-dom";

const Sheet = ({ layout, data, btnOn, btnPath, btnClass, viewBtnText = "View Reports" }) => {
  const navigate = useNavigate();

  return (
    <section className="widget-container">
      {layout.map((row, i) => (
        <div key={i} className="widget-row">
          {row.map((idx) => {
            const widget = WIDGET_COMPONENTS[idx];
            const Component = widget.component;

            return <Component key={idx} data={data} />
          })}
          {btnOn === i && btnPath && <Button className={btnClass} variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(btnPath)}>
            { viewBtnText }
          </Button>}
        </div>
      ))}
    </section>
  );
};

export default Sheet;